function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.31,30.1A13.23,13.23,0,1,1,29.54,16.87,13.24,13.24,0,0,1,16.31,30.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.31,4.65A12.23,12.23,0,1,1,4.09,16.87,12.24,12.24,0,0,1,16.31,4.65m0-2A14.23,14.23,0,1,0,30.54,16.87,14.22,14.22,0,0,0,16.31,2.65Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.53,
    y: 8.87,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.53,
    y: 15.09,
    width: 3.56,
    height: 9.78,
    style: {
      fill: "#00a8e9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.9ffa5079.svg";
export { ForwardRef as ReactComponent };